/* DUK Alle Marken (sections/duk-brands.liquid) — Fassung L2 */
(() => {
  const init = (root) => {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';

    let D = { cats: {}, order: [], stores: {} };
    try { D = JSON.parse(root.querySelector('[data-dbr-data]').textContent); } catch (e) { /* ohne Daten */ }
    const S = D.stores || {};
    const order = (D.order || []).filter((k) => S[k]);

    const $ = (s) => root.querySelector(s);
    const $$ = (s) => Array.from(root.querySelectorAll(s));
    const items = $$('.dbr__it');
    const groups = $$('.dbr__g');
    const bar = $('.dbr__bar');
    const sentinel = $('.dbr__sentinel');
    const sub = $('.dbr__sub');
    const box = $('.dbr__box');
    const boxInfo = $('.dbr__info');
    const boxCall = $('.dbr__call');
    const empty = $('.dbr__empty');
    const list = $('.dbr__list');
    const ix = $$('.dbr__ix a');

    // Zustand: wo = 'online' oder ein Geschäft (s1 …), cat = 'alle' | 'neu' | '1' … '4'
    let wo = 'online';
    let cat = 'alle';
    let lastStore = order[0] || 'online';
    let flip = false;

    const has = (str, v) => (' ' + (str || '') + ' ').indexOf(' ' + v + ' ') >= 0;
    const ok = (it) => {
      const so = it.hasAttribute('data-so');
      const okW = wo === 'online' ? !so : has(it.dataset.s, wo);
      const okC = cat === 'alle' || (cat === 'neu' ? it.hasAttribute('data-neu') : has(it.dataset.c, cat));
      return okW && okC;
    };

    const render = (animate) => {
      items.forEach((it) => { it.hidden = !ok(it); });
      let n = 0;
      groups.forEach((g) => {
        const vis = !!g.querySelector('.dbr__it:not([hidden])');
        g.hidden = !vis;
        if (vis) { g.style.setProperty('--d', Math.min(n * 45, 450) + 'ms'); n++; }
      });
      empty.hidden = n > 0;

      $$('[data-wo-tab]').forEach((b) => {
        const on = b.dataset.woTab === 'online' ? wo === 'online' : wo !== 'online';
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      sub.hidden = wo === 'online';
      $$('[data-store]').forEach((b) => b.setAttribute('aria-pressed', b.dataset.store === wo ? 'true' : 'false'));
      $$('[data-cat]').forEach((b) => b.setAttribute('aria-pressed', b.dataset.cat === cat ? 'true' : 'false'));

      const st = S[wo];
      box.hidden = !st;
      if (st) {
        boxInfo.innerHTML = st.info || '';
        boxCall.hidden = !st.tel;
        boxCall.href = 'tel:' + (st.tel || '');
        boxCall.textContent = (D.call || '{s} · {p}').replace('{s}', st.label).replace('{p}', st.phone);
      }

      ix.forEach((a) => {
        const g = root.querySelector('#dbr-' + a.dataset.l);
        const on = !!g && !g.hidden;
        a.classList.toggle('is-off', !on);
        a.tabIndex = on ? 0 : -1;
        if (on) a.removeAttribute('aria-disabled'); else a.setAttribute('aria-disabled', 'true');
      });

      if (animate) {
        flip = !flip;
        root.classList.toggle('is-flip', flip);
      }
    };

    // Höhe des klebenden Shop-Kopfs (auch wenn er gerade ausgeblendet ist)
    const areaH = () => {
      const t = document.createElement('div');
      t.style.cssText = 'position:absolute;visibility:hidden;pointer-events:none;height:var(--sticky-area-height,0px)';
      document.body.appendChild(t);
      const h = t.offsetHeight;
      t.remove();
      return h;
    };

    // Filterwechsel: klebt die Leiste schon, zurück an den Anfang der Liste
    const update = () => {
      const stuck = bar.classList.contains('is-stuck');
      render(true);
      if (stuck) {
        const top = sentinel.getBoundingClientRect().top + window.scrollY - areaH();
        window.scrollTo({ top: Math.max(0, top), behavior: 'auto' });
      }
    };

    root.addEventListener('click', (e) => {
      const t = e.target.closest('[data-wo-tab],[data-store],[data-cat],[data-reset],.dbr__nm--so,[data-close],.dbr__ix a');
      if (!t) return;
      if (t.matches('.dbr__ix a')) {
        e.preventDefault();
        const g = root.querySelector('#dbr-' + t.dataset.l);
        if (g && !g.hidden) g.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        return;
      }
      if (t.matches('.dbr__nm--so')) { openSheet(t.closest('.dbr__it'), t); return; }
      if (t.hasAttribute('data-close')) { closeSheet(); return; }
      if (t.hasAttribute('data-wo-tab')) {
        const next = t.dataset.woTab === 'online' ? 'online' : (wo === 'online' ? lastStore : wo);
        if (next === wo) return;
        wo = next;
      } else if (t.hasAttribute('data-store')) {
        if (t.dataset.store === wo) return;
        wo = lastStore = t.dataset.store;
        t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      } else if (t.hasAttribute('data-cat')) {
        if (t.dataset.cat === cat) return;
        cat = t.dataset.cat;
      } else if (t.hasAttribute('data-reset')) {
        wo = 'online';
        cat = 'alle';
      }
      update();
    });

    // Linie unter der Leiste nur, solange sie klebt; Höhe der Leiste für Buchstaben und Sprungziele
    let ticking = false;
    const onScroll = () => {
      ticking = false;
      const top = parseFloat(getComputedStyle(bar).top) || 0;
      bar.classList.toggle('is-stuck', window.scrollY > 0 && sentinel.getBoundingClientRect().top < top - 0.5);
    };
    window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
    const setBarH = () => root.style.setProperty('--dbr-bar-h', bar.offsetHeight + 'px');
    if ('ResizeObserver' in window) new ResizeObserver(setBarH).observe(bar);
    setBarH();
    onScroll();

    // Bild beim Darüberfahren (desktop, Maus): Bilder vorab laden, Rahmen erst zeigen, wenn das Bild da ist
    const mq = matchMedia('(min-width: 1000px) and (hover: hover)');
    const peek = $('.dbr__peek');
    const frame = $('.dbr__pf');
    const imgs = {};
    let cur = null;
    const imgFor = (src) => {
      let im = imgs[src];
      if (!im) {
        im = document.createElement('img');
        im.alt = '';
        im.decoding = 'async';
        im.src = src;
        frame.appendChild(im);
        imgs[src] = im;
      }
      return im;
    };
    let preloaded = false;
    const preload = () => {
      if (preloaded || !mq.matches) return;
      preloaded = true;
      $$('.dbr__nm[data-img]').forEach((a) => imgFor(a.dataset.img));
    };
    const idle = (f) => (window.requestIdleCallback ? window.requestIdleCallback(f, { timeout: 3000 }) : setTimeout(f, 1500));
    if (document.readyState === 'complete') idle(preload); else window.addEventListener('load', () => idle(preload), { once: true });
    list.addEventListener('mouseenter', preload);
    const show = (src) => {
      if (src === cur) return;
      cur = src;
      Object.keys(imgs).forEach((k) => imgs[k].classList.remove('is-on'));
      if (!src) { peek.classList.remove('is-on'); return; }
      const im = imgFor(src);
      const on = () => {
        if (cur !== src) return;
        im.classList.add('is-on');
        peek.classList.add('is-on');
      };
      if (im.complete && im.naturalWidth) on();
      else { peek.classList.remove('is-on'); im.addEventListener('load', on, { once: true }); }
    };
    // Lage: ruhig neben dem Namen, über dem der Zeiger steht (nicht dem Zeiger nach); gleitet weich von Name zu Name.
    // Kurze Verzögerung, damit beim schnellen Überfahren nicht jedes Bild aufblitzt. Bezugspunkt wird gemessen.
    const origin = document.createElement('i');
    origin.setAttribute('aria-hidden', 'true');
    origin.style.cssText = 'position:fixed;top:0;left:0;width:0;height:0;pointer-events:none;visibility:hidden';
    peek.parentNode.insertBefore(origin, peek);
    let tx = 0, ty = 0, px = 0, py = 0, raf = 0, placed = false, mx = -1, my = -1, curA = null, timer = 0;
    const step = () => {
      px += (tx - px) * 0.22;
      py += (ty - py) * 0.22;
      peek.style.transform = 'translate3d(' + px.toFixed(1) + 'px,' + py.toFixed(1) + 'px,0)';
      raf = (Math.abs(tx - px) > 0.4 || Math.abs(ty - py) > 0.4) ? requestAnimationFrame(step) : 0;
    };
    const anchorTo = (a) => {
      const lb = a.querySelector('.dbr__lb') || a;
      const r = lb.getBoundingClientRect();
      const o = origin.getBoundingClientRect();
      const w = frame.offsetWidth || 120, h = frame.offsetHeight || 140;
      let x = r.right + 16;
      if (x + w > window.innerWidth - 16) x = r.left - w - 16;
      tx = x - o.left;
      ty = Math.max(8, r.top + r.height / 2 - h / 2) - o.top;
      if (!placed) { px = tx; py = ty; placed = true; peek.style.transform = 'translate3d(' + px + 'px,' + py + 'px,0)'; }
      if (!raf) raf = requestAnimationFrame(step);
    };
    const hide = () => { clearTimeout(timer); curA = null; show(null); placed = false; };
    const pick = (a) => {
      if (a && !a.dataset.img) a = null;
      if (a === curA) return;
      curA = a;
      clearTimeout(timer);
      if (!a) { timer = setTimeout(hide, 250); return; }
      timer = setTimeout(() => { anchorTo(a); show(a.dataset.img); }, 70);
    };
    list.addEventListener('mouseover', (e) => {
      if (!mq.matches) return;
      mx = e.clientX;
      my = e.clientY;
      pick(e.target.closest('.dbr__nm'));
    });
    list.addEventListener('mousemove', (e) => { mx = e.clientX; my = e.clientY; });
    // Scrollen ohne Mausbewegung: Bild zur Marke unter dem Zeiger
    window.addEventListener('scroll', () => {
      if (mx < 0 || !mq.matches) return;
      const el = document.elementFromPoint(mx, my);
      if (!el || !list.contains(el)) { hide(); return; }
      const a = el.closest('.dbr__nm');
      if (a && a === curA) anchorTo(a); else pick(a);
    }, { passive: true });
    list.addEventListener('mouseleave', () => { hide(); mx = -1; });

    // Blatt „Nur im Geschäft“
    const sheet = $('.dbr__sheet');
    const panel = $('.dbr__panel');
    const more = $('.dbr__more');
    let opener = null;
    let closeTimer = null;
    const esc = (s) => String(s || '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    const onKey = (e) => {
      if (e.key === 'Escape') { e.preventDefault(); closeSheet(); return; }
      if (e.key !== 'Tab') return;
      const f = Array.from(panel.querySelectorAll('a[href]:not([hidden]),button:not([hidden])')).filter((el) => el.offsetParent !== null);
      if (!f.length) return;
      const a = f[0], z = f[f.length - 1];
      if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
      else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
    };
    const openSheet = (it, trigger) => {
      if (!it) return;
      clearTimeout(closeTimer);
      opener = trigger;
      const name = it.querySelector('.dbr__n').textContent.trim();
      $('.dbr__sname').textContent = name;
      $('.dbr__scats').textContent = (it.dataset.c || '').split(' ').filter(Boolean).map((c) => (D.cats || {})[c]).filter(Boolean).join(' · ');
      $('.dbr__rows').innerHTML = order.filter((k) => has(it.dataset.s, k)).map((k) => {
        const st = S[k];
        return '<a class="dbr__row" href="' + esc(st.url) + '"><span>' + esc(st.label) + '</span><span>' + esc(st.street) + '</span></a>';
      }).join('');
      if (it.dataset.page) {
        more.href = it.dataset.page;
        more.textContent = (D.more || '{n}').replace('{n}', name);
        more.hidden = false;
      } else {
        more.hidden = true;
      }
      sheet.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(() => requestAnimationFrame(() => sheet.classList.add('is-open')));
      document.addEventListener('keydown', onKey);
      const x = $('.dbr__x');
      if (x) x.focus({ preventScroll: true });
    };
    const closeSheet = () => {
      if (sheet.hidden) return;
      sheet.classList.remove('is-open');
      document.removeEventListener('keydown', onKey);
      document.documentElement.style.overflow = '';
      const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
      closeTimer = setTimeout(() => { sheet.hidden = true; }, reduce ? 0 : 360);
      if (opener) opener.focus({ preventScroll: true });
    };

    render(false);
  };

  const boot = () => document.querySelectorAll('[data-dbr]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
